import { ScrollView } from "../ScrollView.js";
import { IScrollViewLimit } from "./IScrollViewLimit.js";

export class ScrollViewLimitCenter implements IScrollViewLimit {
    public getMinX(view: ScrollView, scale: number = view.scale): number {
        return (view.width - view.contentWidth * scale) * 0.5;
    }

    public getMaxX(view: ScrollView, scale: number = view.scale): number {
        return (view.width - view.contentWidth * scale) * 0.5;
    }

    public getMinY(view: ScrollView, scale: number = view.scale): number {
        return (view.height - view.contentHeight * scale) * 0.5;
    }

    public getMaxY(view: ScrollView, scale: number = view.scale): number {
        return (view.height - view.contentHeight * scale) * 0.5;
    }
}